import { graphql } from '../../__generated__';

export const ADD_ASSET_TO_WATCHLIST = graphql(`
  mutation AddAssetToWatchList($assetId: Int!) {
    addAssetToWatchList(assetId: $assetId) {
      assetId
    }
  }
`);
